import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import areValuesEqual from 'utils/areValuesEqual';
var excludedKeys = ['id'];
var keysWithStringValues = ['name', 'description'];
export function updateContentItem(_ref) {
  var item = _ref.item,
    patchData = _ref.patchData,
    initialItem = _ref.initialItem;
  var newChangedFields = new Set(item.changedFields);
  for (var key in patchData) {
    if (!excludedKeys.includes(key)) {
      // `areValuesEqual` works for primitive types,
      // more complex objects or arrays might need special handling
      var wasFieldChanged = void 0;
      if (keysWithStringValues.includes(key)) {
        wasFieldChanged = !areValuesEqual(
        // Fallback to '' so added and then immediately cleared values are not considered as changes
        initialItem[key] || '', patchData[key]);
      } else if (key === 'thumbnailId') {
        wasFieldChanged = !areValuesEqual(
        // Fallback to 'null' so added and then immediately cleared values are not considered as changes
        initialItem[key] || null, patchData[key]);
      } else {
        wasFieldChanged = !areValuesEqual(initialItem[key], patchData[key]);
      }
      if (wasFieldChanged) {
        newChangedFields.add(key);
      } else {
        newChangedFields.delete(key);
      }
    }
  }

  // Casting this to `ContentManagerItem` as TS isn't happy about
  // various properties in `patchData` not matching those in `item`.
  // Not sure what the proper way to resolve this would be… :(
  return _objectSpread(_objectSpread(_objectSpread({}, item), patchData), {}, {
    changedFields: newChangedFields
  });
}